import { render, staticRenderFns } from "./riskPerception.vue?vue&type=template&id=42b709e9&scoped=true&"
import script from "./riskPerception.vue?vue&type=script&lang=js&"
export * from "./riskPerception.vue?vue&type=script&lang=js&"
import style0 from "./riskPerception.vue?vue&type=style&index=0&id=42b709e9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42b709e9",
  null
  
)

export default component.exports